export const UPDATE_CASINO_GAMES = 'UPDATE_CASINO_GAMES';
export const SET_CASINO_GAME = 'SET_CASINO_GAME';
export const UPDATE_GAME_DATA = 'UPDATE_GAME_DATA';
export const UPDATE_GAME_RESULTS = 'UPDATE_GAME_RESULTS';
